import {
  preFormatForm,
  taskConstraints,
  trimInputValues,
  validateForm,
  getTranslatedText,
  IndicatorSeparator,
  DropdownIndicator,
  ActionGroup,
  TEXT_LENGTH
} from '@nile/components';
import { EmailEditor } from '@nile/banyan/src/Components/Editors';
import {
  AccountClient,
  GET_ALL_TECHS_NEW,
  GET_ALL_TECH_GROUP
} from '@nile/graphql';
import {
  Page,
  TextField,
  Heading,
  Avatar,
  Label,
  Dropdown,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import dompurify from 'dompurify';
import dayjs from 'dayjs';
import React, { Component } from 'react';
import styled from 'styled-components';
import { cloneDeep } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import { reactSelectErrorStyles, reactSelectInlineError } from '../Utils/style';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const TaskTemplateContainer = styled.div`
  .ml-8 {
    margin-left: 8px;
  }
  .w50 {
    width: 50%;
  }

  .ql-editor.ql-blank::before {
    left: 10px;
  }

  // TODO - GA cleanup
  .template-name {
    width: 450px;
  }

  .time-unit-holder {
    background: #efefef;
    padding: 8px;
    border-radius: 8px 8px 0px 0px;
    border-bottom: 1px solid rgba(151, 151, 151, 0.3);
  }
`;

const EditorHolder = styled.div`
  #quill-rt-editor {
    height: 100%;
    .quill {
      min-height: 200px;
      .ql-container {
        border: none;
        min-height: inherit;
        .ql-editor {
          min-height: inherit;
          padding-left: 10px !important;
          padding-right: 10px !important;
        }
      }
    }
    .ql-toolbar {
      border: none;
      padding: 8px 0 !important;
    }
  }
`;

class TaskTemplateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      task: {
        name: props.type ? props.task.name : props?.data?.title || '',
        description: props?.data?.description || '',
        estimatedTime: props?.data?.estimatedTime || 0,
        technician: props?.data?.technician,
        techGroup: props?.data?.techGroup
      },
      template: {
        name: '',
        content: dompurifier(props?.data?.description) || '',
        placeholdersUsed: '',
        inlineImages: []
      },
      hrValue: 0,
      minValue: 0,
      allTechGroups: null,
      allTechnicians: null,
      allAvailableTechs: null,
      errors: null,
      submitActionLoading: false
    };
  }

  handleChange(field) {
    return (value) => {
      const { task } = this.state;
      task[field] = value;
      this.setState({ task: task });
    };
  }

  updateStatus = (statusObj) => {
    const { task } = this.state;
    const updatedTask = { ...task };
    updatedTask.status = statusObj.name;
    this.setState({ task: updatedTask });
  };

  selectDateHandler = (val, type) => {
    const date = new Date(val);
    const formatted = dayjs(date).format('YYYY-MM-DDTHH:mm:ss');
    const { task } = this.state;
    const updatedTask = { ...task };
    updatedTask[type] = formatted;
    this.setState({ task: updatedTask });
  };

  handleTimeCalculation = (val, type) => {
    const newVal = val || '0';
    this.setState({ [type]: val });
    const { hrValue, minValue } = this.state;
    const calculatedMins =
      type === 'hrValue'
        ? parseInt(newVal * 60, 10) + parseInt(minValue, 10)
        : parseInt(hrValue * 60, 10) + parseInt(newVal, 10);
    const { task } = this.state;
    const updatedTask = { ...task };
    updatedTask.estimatedTime = calculatedMins;
    this.setState({ task: updatedTask });
  };

  constructSelectObj = (obj) => {
    if (obj) {
      const { label, description, userList, clientList, value, ...rest } = obj;
      return rest;
    }
    return null;
  };

  getDropdownOptions = (arr) => {
    if (arr && arr.length > 0) {
      return arr.map((el) => ({ ...el, value: el?.name }));
    } else {
      return [];
    }
  };

  createTask = () => {
    this.setState({ submitActionLoading: true });
    const dummyForm = { ...this.state.task };
    dummyForm.description = dompurifier(this.state.template.content);
    const validationResult = validateForm(
      preFormatForm(dummyForm),
      taskConstraints
    );
    if (validationResult) {
      this.setState({ errors: validationResult, submitActionLoading: false });
      return;
    }
    this.setState({ errors: {} });
    let trimmedForm = { ...this.state.task };
    trimmedForm = trimInputValues(trimmedForm);
    trimmedForm.description = dompurifier(this.state.template.content);
    trimmedForm.technician = this.constructSelectObj(trimmedForm.technician);
    trimmedForm.techGroup = this.constructSelectObj(trimmedForm.techGroup);
    trimmedForm.inlineImages = this.state.template?.inlineImages || [];
    this.props.handleTaskCreation(trimmedForm);
  };

  updateTemplate = (obj) => {
    const updatedTemplate = cloneDeep(this.state.template);
    this.setState({ template: { ...updatedTemplate, ...obj } });
  };

  componentDidMount = () => {
    if (this.props?.data?.estimatedTime) {
      const actualTime = this.props.data.estimatedTime;
      const hrs = `${Math.floor(actualTime / 60)}`;
      const mins = `${actualTime % 60}`;
      this.setState({ hrValue: hrs, minValue: mins });
    }
    AccountClient.query({
      query: GET_ALL_TECH_GROUP,
      fetchPolicy: 'network-only'
    }).then((res) => {
      if (res.data.getTechnicianGroups) {
        if (this.props?.data?.techGroup) {
          const currentTechGroup = res.data.getTechnicianGroups.filter(
            (grp) => grp.groupId === this.props.data.techGroup.groupId
          );
          const allUsers = currentTechGroup?.[0]?.userList;
          this.setState({
            allTechGroups: res.data.getTechnicianGroups.map((item) => ({
              ...item,
              label: item.name
            })),
            allTechnicians: allUsers.map((item) => ({
              ...item,
              label: item.name
            }))
          });
        } else {
          this.setState({
            allTechGroups: res.data.getTechnicianGroups.map((item) => ({
              ...item,
              label: item.name
            }))
          });
        }
      }
    });
    AccountClient.query({
      query: GET_ALL_TECHS_NEW,
      fetchPolicy: 'network-only',
      variables: {
        input: {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        }
      }
    }).then((res) => {
      if (res.data?.getTechnicianList?.userList) {
        this.setState({
          allAvailableTechs: res.data.getTechnicianList.userList.map(
            (item) => ({
              ...item,
              label: item.name
            })
          )
        });
      }
    });
    if (!this.props?.data?.techGroup) {
      AccountClient.query({
        query: GET_ALL_TECHS_NEW,
        variables: {
          input: {
            listInfo: {
              sort: {
                attribute: 'name',
                order: 'ASC'
              }
            }
          }
        }
      }).then((res) => {
        if (res.data?.getTechnicianList?.userList) {
          this.setState({
            allTechnicians: res.data.getTechnicianList.userList.map((item) => ({
              ...item,
              label: item.name
            }))
          });
        }
      });
    }
  };

  handleTechGroupSelect = (value) => {
    if (value) {
      const selected = this.state.allTechGroups?.find(
        (group) => group.groupId === value.groupId
      );
      return selected ? { ...selected, value: selected?.name } : null;
    }
    return null;
  };

  handleTechicianSelect = (value) => {
    if (value) {
      const selected = this.state.allTechnicians?.find(
        (user) => user.userId === value.userId
      );
      return selected ? { ...selected, value: selected?.name } : null;
    }
    return null;
  };

  updateSelectFields(key, field) {
    const { task } = this.state;
    task[key] = field;
    if (key === 'techGroup') {
      if (field) {
        const allUsers = field.userList.map((item) => ({
          ...item,
          label: item.name
        }));
        if (!allUsers.find((user) => user.userId === task.technician?.userId)) {
          task.technician = null; //null case to reset technician
        }
        this.setState({ task: task, allTechnicians: allUsers });
      } else {
        task.technician = null; //null case to reset technician
        this.setState({
          task: task,
          allTechnicians: this.state.allAvailableTechs
        });
      }
    } else {
      this.setState({ task: task });
    }
  }

  render() {
    const {
      task,
      errors,
      hrValue,
      minValue,
      submitActionLoading,
      template
    } = this.state;
    const {
      intl,
      type,
      toggleSheetActive,
      meta,
      data,
      onSaveHandler,
      onCancelHandler,
      module,
      details,
      title
    } = this.props;

    return (
      <div className="full-height p20 white-grey-page">
        <Page
          variant="primary"
          contentHeight="120px"
          title={
            <TextStyle weight="Bold">
              {title || (
                <FormattedMessage id="admin.taskTemplate.create.header" />
              )}
            </TextStyle>
          }
          primaryAction={
            <ActionGroup
              secondaryAction={onCancelHandler}
              secondaryText={<FormattedMessage id="common.cancel" />}
              primaryAction={this.createTask}
              primaryLoading={submitActionLoading}
              primaryText={<FormattedMessage id="common.save" />}
            />
          }
        >
          <TaskTemplateContainer>
            <div className="SOP-Task-Details mb80">
              <>
                <div superid="taskName" className="template-name mb-10 ml-8">
                  <TextField
                    noborder
                    fontSize="fontLarge"
                    placeholder={getTranslatedText(intl, 'common.name')}
                    value={task.name}
                    onChange={this.handleChange('name')}
                    error={errors?.name?.[0]}
                    maxLength={TEXT_LENGTH.size_7}
                  />
                </div>
                <EditorHolder>
                  <EmailEditor
                    template={template}
                    updateTemplate={this.updateTemplate}
                    // handleFileAttachments={this.handleFileAttachments}
                    placeholder={getTranslatedText(
                      intl,
                      'admin.taskTemplates.create.h2.details.pl2'
                    )}
                    module={module || 'TASK_TEMPLATE'}
                    details={details || { operation: 'CREATE' }}
                  />
                </EditorHolder>
              </>
            </div>
            <>
              <div className="mb-20 ml-10">
                <Heading element="h3">
                  <FormattedMessage id="admin.taskTemplate.create.h2.assignment" />
                </Heading>
              </div>
              <div className="ml-12 mb-20 w50">
                <Label id="employeePhoneLabel">
                  <FormattedMessage id="admin.taskTemplate.create.h2.assignment.l1" />
                </Label>
                <div className="fx actr">
                  <div className="mr-10">
                    <SVGIcon name="TechnicianGroup" />
                  </div>
                  <div className="f11">
                    <Dropdown
                      isClearable
                      value={this.handleTechGroupSelect(task?.techGroup)}
                      styles={
                        errors?.groupId
                          ? {
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999
                              }),
                              ...reactSelectErrorStyles
                            }
                          : {
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 999999
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999
                              })
                            }
                      }
                      components={{
                        IndicatorSeparator,
                        DropdownIndicator
                      }}
                      name="team"
                      onChange={this.updateSelectFields.bind(this, 'techGroup')}
                      options={this.getDropdownOptions(
                        this.state.allTechGroups
                      )}
                    />
                    {errors?.groupId &&
                      reactSelectInlineError(errors.groupId[0])}
                  </div>
                </div>
              </div>

              <div className="ml-12 mb-20 w50">
                <Label id="employeePhoneLabel">
                  <FormattedMessage id="admin.taskTemplate.create.h2.assignment.l2" />
                </Label>
                <div className="fx actr">
                  <Avatar customer name="Owner" size="extraSmall" />
                  <div className="f11">
                    <div superid="taskTechnician">
                      <Dropdown
                        value={this.handleTechicianSelect(task?.technician)}
                        isClearable
                        styles={
                          errors?.technician
                            ? {
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999
                                }),
                                menu: (base) => ({
                                  ...base,
                                  zIndex: 9999
                                }),
                                ...reactSelectErrorStyles
                              }
                            : {
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999
                                }),
                                menu: (base) => ({
                                  ...base,
                                  zIndex: 9999
                                })
                              }
                        }
                        components={{
                          IndicatorSeparator,
                          DropdownIndicator
                        }}
                        name="team"
                        onChange={this.updateSelectFields.bind(
                          this,
                          'technician'
                        )}
                        options={this.getDropdownOptions(
                          this.state.allTechnicians
                        )}
                      />
                      {errors?.technician &&
                        reactSelectInlineError(errors.technician)}
                    </div>
                  </div>
                </div>
              </div>

              <div className="ml-12 mb-20 w50" superid="taskEstimatedTime">
                <Label id="employeePhoneLabel">
                  <FormattedMessage id="admin.taskTemplate.create.h2.assignment.l3" />
                </Label>
                <div className="fx actr mt-10">
                  <div className="mr-10">
                    <SVGIcon name="EstimatedTime" />
                  </div>
                  <div className="f11">
                    <div className="fx actr">
                      <div className="mr-10" superid="taskEstHours">
                        <TextField
                          size="extrasmall"
                          type="number"
                          value={hrValue}
                          onChange={(val) =>
                            this.handleTimeCalculation(val, 'hrValue')
                          }
                          inputMode="numeric"
                          min={0}
                          suffix={getTranslatedText(
                            intl,
                            'admin.runbooks.tasks.copy.hour'
                          )}
                        />
                      </div>

                      <div className="mr-10" superid="taskEstMins">
                        <TextField
                          size="extrasmall"
                          type="number"
                          value={minValue}
                          onChange={(val) =>
                            this.handleTimeCalculation(val, 'minValue')
                          }
                          inputMode="numeric"
                          min={0}
                          suffix={getTranslatedText(
                            intl,
                            'admin.runbooks.tasks.copy.min'
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </TaskTemplateContainer>
        </Page>
      </div>
    );
  }
}

export default injectIntl(TaskTemplateForm);
